export default __webpack_public_path__ + "static/media/common-iv-audio@2x.eed71772.png";